import { render, staticRenderFns } from "./subsidyInformation.vue?vue&type=template&id=5f2798c9&scoped=true"
import script from "./subsidyInformation.vue?vue&type=script&lang=js"
export * from "./subsidyInformation.vue?vue&type=script&lang=js"
import style0 from "./subsidyInformation.vue?vue&type=style&index=0&id=5f2798c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2798c9",
  null
  
)

export default component.exports